import { useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import { backPressHandlersAtom } from "web_myplann/Shared/State/backPressHandlersAtom";

export const useCloseOnBackPress = (open: boolean, onClose?: () => void) => {
	const setBackPressHandlers = useSetAtom(backPressHandlersAtom);
	const onCloseRef = useRef(onClose);

	useEffect(() => {
		onCloseRef.current = onClose;
	});

	useEffect(() => {
		if (!open) return;
		const handler = () => onCloseRef.current?.();
		setBackPressHandlers((handlers) => [...handlers, handler]);
		return () => {
			setBackPressHandlers((handlers) =>
				handlers.filter((registered) => registered !== handler),
			);
		};
	}, [open, setBackPressHandlers]);
};
